import { Box, Typography } from "@mui/material";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";
import CardStatus from "@arelia-components/ui-atoms/CardStatus";
import { Widget } from "@arelia-types/widget";

type Props = {
  total: number | undefined;
  changes: number;
  loading: boolean;
  widgetConfig: Widget;
};

export default function CustomersPresenter({ total, changes, widgetConfig, loading }: Props) {
  return (
    <WidgetCard
      widgetId={widgetConfig.id}
      title={widgetConfig.name}
      loading={loading}
      widgetConfig={widgetConfig}
      disableFavorite={true}
      navigateLink="/hq/customers"
      footerText="View all Customers"
    >
      <Box sx={styles.container}>
        <Typography variant="h2">{total} Customers</Typography>
        <CardStatus color={changes > 0 ? "success.main" : "error"}>
          {changes > 0 ? (
            <ArrowUpward color="success" />
          ) : (
            <ArrowDownward color="error" />
          )}
          {Math.abs(Math.round(changes))}% FROM LAST QUARTER
        </CardStatus>
      </Box>
    </WidgetCard>
  );
}

const styles = {
  container: {
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  }
}